export default function showStartupError(err) {
  console.error(err);
  var style = document.createElement('style');
  style.textContent = "\n    .app-startup-error {\n      position: fixed;\n      top: 20px;\n      left: 20px;\n      right: 20px;\n      background: #fff;\n      border: 1px solid #ccc;\n      padding: 40px;\n      z-index: 9999;\n      overflow: auto;\n      font-family: sans-serif;\n      box-shadow: 0 0 10px rgba(0,0,0,0.5);\n    }\n    .app-startup-error-close {\n      position: absolute;\n      right: 40px;\n      top: 40px;\n      border: none;\n      background: none;\n      font-size: 40px;\n      cursor: pointer;\n      line-height: 1;\n      padding: 0;\n    }\n  ";
  document.head.appendChild(style);
  var errorDiv = document.createElement('div');
  errorDiv.className = 'app-startup-error';
  var closeButton = document.createElement('button');
  closeButton.className = 'app-startup-error-close';
  closeButton.innerHTML = '×';
  closeButton.setAttribute('aria-label', 'Close');
  closeButton.onclick = function () {
    errorDiv.remove();
    style.remove();
  };
  var h1 = document.createElement('h1');
  h1.textContent = 'Application Startup Error';
  var timeCode = document.createElement('code');
  timeCode.textContent = new Date().toISOString();
  var userAgentP = document.createElement('p');
  userAgentP.textContent = "User Agent: ".concat(navigator.userAgent);
  var message = err instanceof Error ? err.message : String(err);
  var errMessageP = document.createElement('p');
  errMessageP.textContent = "Error: ".concat(message);
  var stackTraceP = document.createElement('p');
  stackTraceP.textContent = 'Stack Trace:';
  errorDiv.append(closeButton, h1, timeCode, userAgentP, errMessageP, stackTraceP);
  var stack = err instanceof Error && err.stack;
  if (stack) {
    var stackTracePre = document.createElement('pre');
    stackTracePre.textContent = stack;
    errorDiv.append(stackTracePre);
  }
  document.body.appendChild(errorDiv);
}